






















































































import { plainToInstance } from 'class-transformer'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import {
  ChannelInfo,
  ErrorChannelInfo,
  SuccessChannelInfo
} from '../../../../../../../../../../../models/CheckChannels/CheckChannels'
import { UseFields } from '../../../../../../../../../../Pi'
import CustomEditor from '../../../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../../../Helpers/ChannelsInfoHelper'
import { KickActionProxy } from '../../../../logic/Actions/KickAction/KickActionProxy'
import { ActionNodeProps } from '../../../../logic/types'
import NotifyGroupActionSetChannelField from '../NotifyGroupAction/components/NotifyGroupActionSetChannelField.vue'

@Component({
  components: {
    NotifyGroupActionSetChannelField
  },
  data() {
    return {
      SuccessChannelInfo,
      ErrorChannelInfo
    }
  }
})
export default class KickActionSidebar extends Mixins<UseFields>(UseFields) {
  @Prop() proxyAction!: KickActionProxy

  @Prop() targetOptions!: ActionNodeProps['targetOptions']

  @Prop() targets!: ActionNodeProps['targets']

  @Prop() editor!: CustomEditor

  isLoading = false

  checkChannelHandler(channelData: string | number): void {
      this.isLoading = true

      this.editor.getChannelsInfo([ channelData ])
        .then(({ data }) => {
          const channelInfo = data[0]

          if (channelInfo instanceof SuccessChannelInfo) {
            this.proxyAction.setToTargets(channelInfo.info.id)
            this.proxyAction.removeErrorTarget(channelData.toString())
          }
        })
      .finally(() => {
        this.isLoading = false
      })
  }

  get tableTargets() {
    return [
      ...this.proxyAction.action.targets,
      ...this.proxyAction.errorTargets
    ]
      .filter(id => !!id)
      .map(id => {
        const existedTarget = this.targets().find(t => t.id === id)

        if (existedTarget) {
          return plainToInstance(SuccessChannelInfo, {
            status: true,
            info: {
              id: existedTarget.id,
              login: existedTarget.login,
              title: existedTarget.title,
            }
          })
        }

        const channel = ChannelsInfoHelper.GetChannel(id!.toString())

        if (!channel?.status) {
          return plainToInstance(ErrorChannelInfo, channel)
        } else {
          return plainToInstance(SuccessChannelInfo, channel)
        }
      })
      .filter(target => !!target)
  }

  removeTarget(target: ChannelInfo): void {
    if (target instanceof SuccessChannelInfo) {
      this.proxyAction.removeTarget(target.info.id)
    }

    if (target instanceof ErrorChannelInfo) {
      this.proxyAction.removeErrorTarget(target.value)
    }
  }
}
